import { render } from "./WNAbnormalCallListCY.vue?vue&type=template&id=5337c76c&scoped=true"
import script from "./WNAbnormalCallListCY.vue?vue&type=script&lang=js"
export * from "./WNAbnormalCallListCY.vue?vue&type=script&lang=js"

import "./WNAbnormalCallListCY.vue?vue&type=style&index=0&id=5337c76c&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-5337c76c"

export default script